import React from 'react';
interface KeyTurnMarkProps {
  size?: number;
  /** The mark is one colour. Gold on charcoal, charcoal on cream. */
  ink?: string;
  className?: string;
}

/**
 * A 270° arc opening on a 90° keyway at the base - the brand cut. Deliberately
 * drawn differently from the Health dial, which opens 40°.
 */
export function KeyTurnMark({
  size = 28,
  ink = '#C9A84C',
  className = ''
}: KeyTurnMarkProps) {
  return <svg viewBox="0 0 100 100" width={size} height={size} className={`block ${className}`} aria-hidden="true" focusable="false" data-id="element-26" data-mp="1et3smxeu322s">
      <path d="M 21.716 78.284 A 40 40 0 1 1 78.284 78.284" fill="none" stroke={ink} strokeWidth={size < 22 ? 18 : 15} strokeLinecap="round" data-id="element-27" data-mp="1nt0bgiejl6px" />
    </svg>;
}